/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics/FctParams';
import { LIDO_STETH_TOKEN } from '../constants';
export var GetSharesByPooledETH = createPlugin({
    protocol: 'LIDO',
    type: 'GETTER',
    method: 'getSharesByPooledEth',
    supportedContracts: LIDO_STETH_TOKEN,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                ethAmount: new FctValue18({}),
            },
        },
        output: {
            shares: new FctValue18({}),
        },
    }); },
});
